<template>
	<div v-if="options.length">
		<h2 class="menu-label">{{ label }}</h2>

		<ul class="menu-list">
			<li v-for="option in options" :key="option.key">
				<a
					href="#"
					role="button"
					:aria-pressed="isSelected(option) ? 'true' : 'false'"
					:class="{
						'is-active': isSelected(option),
						'is-unavailable': isTermGreyedOut(option) && !isSelected(option),
					}"
					@click.prevent="toggleSelection(option.key)"
					@keydown.space.prevent="toggleSelection(option.key)"
				>
					<span>{{ option.term }}</span>
				</a>
			</li>
		</ul>
	</div>
</template>

<script>

import { getFilteredPostings } from '../helpers/postings.js';
import filterMixin from '../mixins/filter.js';

export default {
	mixins: [filterMixin],

	props: {
		/* User-facing heading for this filter group */
		label: {
			type: String,
			required: true,
		},
	},

	computed: {
		/* Number of openings each option would show if selected on its own, given the other filters */
		optionPostingCounts() {
			const counts = {};

			for (const option of this.options) {
				const potentialDepartments = this.taxonomy === 'departments' ? [option.key] : this.$store.filter.departments;
				const potentialLocations = this.taxonomy === 'locations' ? [option.key] : this.$store.filter.locations;
				const potentialWorkplaceTypes = this.taxonomy === 'workplaceTypes' ? [option.key] : this.$store.filter.workplaceTypes;
				const potentialPostings = getFilteredPostings(
					this.$store.postings,
					potentialDepartments,
					potentialLocations,
					potentialWorkplaceTypes,
				);

				counts[option.key] = potentialPostings.length;
			}

			return counts;
		},
	},

	methods: {
		/* Analytics event id for this component's selection events */
		analyticsEventName(key) {
			return `job-openings-filter-${this.taxonomy}-${key}`;
		},

		isSelected(option) {
			return this.selection.includes(option.key);
		},

		isTermGreyedOut(option) {
			return this.optionPostingCounts[option.key] === 0;
		},
	},
};

</script>

<style lang="scss" scoped>
@import '@gearset/web-core/styles/includes/variables';

.menu-list a {
	padding: 1px;
	border-radius: 0;
	background-color: transparent;

	&:hover,
	&.is-active {
		background-color: transparent;
	}

	span {
		display: block;
		padding: $menu-list-link-padding;
		border-radius: $menu-item-radius;
	}

	&:hover span {
		background-color: $white-ter;
	}

	&.is-unavailable {
		color: $grey-light;

		&:hover {
			color: $grey-light;
		}
	}

	&.is-active {
		color: $white;

		span {
			background-color: $blue;
			color: $white;
		}

		&:hover span {
			background-color: $blue;
		}
	}
}
</style>
